import { ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import DropdownMenu from "../../ui/DropdownMenu";

export default function ClientList({
  clients,
  onSelect,
  onArchive,
  onRestore,
  onDelete,
}) {
  const [menuClient, setMenuClient] = useState(null);
  const [anchorRect, setAnchorRect] = useState(null);

  function openMenu(e, client) {
    e.stopPropagation();
    setMenuClient(client);
    setAnchorRect(e.currentTarget.getBoundingClientRect());
  }

  function closeMenu() {
    setMenuClient(null);
    setAnchorRect(null);
  }

  return (
    <div className="bg-white border border-[var(--color-border)] rounded-lg">
      {/* Header */}
      <div className="px-5 py-3 border-b text-xs text-[var(--color-text-muted)]">
        Showing {clients.length} clients
      </div>

      {clients.length === 0 && (
        <div className="px-5 py-16 text-center text-sm text-[var(--color-text-muted)]">
          No clients match your search
        </div>
      )}

      {/* Rows */}
      <div className="divide-y divide-[var(--color-divider)]">
        {clients.map((client) => (
          <div
            key={client.id}
            onClick={() => onSelect(client)}
            className={`
     group
    px-5 py-4
    flex items-center justify-between
    cursor-pointer
    rounded-md
    transition
    hover:bg-[var(--color-bg-muted)]
    hover:shadow-sm
    ${client.archived_at ? "opacity-60" : ""}
  `}
          >
            {/* LEFT */}
            <div className="space-y-1">
              <div className="font-medium text-sm">{client.name}</div>

              <div className="flex items-center gap-2 text-xs text-[var(--color-text-muted)]">
                <span>
                  {client.city || "—"}, {client.country || "India"}
                </span>
                <span className="w-1 h-1 rounded-full bg-gray-300" />
                <span
                  className={
                    client.archived_at ? "text-gray-500" : "text-emerald-600"
                  }
                >
                  {client.archived_at ? "Archived" : "Active"}
                </span>
              </div>
            </div>

            {/* RIGHT */}
            <div className="flex items-center gap-4">
              <div className="text-right">
                <div className="text-sm font-medium">
                  ₹ {client.totalBilled || 0}
                </div>
                <div className="text-[11px] text-[var(--color-text-muted)]">
                  {client.invoiceCount || 0} invoices
                </div>
              </div>

              <ChevronRight className="text-gray-400" />

              <button
                onClick={(e) => openMenu(e, client)}
                className="
                  opacity-0
                  group-hover:opacity-100
                  p-1 rounded-md
                  hover:bg-gray-100
                "
              >
                ⋯
              </button>
            </div>
          </div>
        ))}
      </div>

      {menuClient && (
        <DropdownMenu anchorRect={anchorRect} onClose={closeMenu}>
          {/* Edit always */}
          <button
            onClick={() => {
              closeMenu();
              onSelect(menuClient);
            }}
            className="w-full text-left px-3 py-2 hover:bg-gray-50"
          >
            Edit
          </button>

          {!menuClient.archived_at ? (
            <button
              onClick={() => {
                closeMenu();
                onArchive(menuClient);
              }}
              className="w-full text-left px-3 py-2 text-red-600 hover:bg-red-50"
            >
              Archive
            </button>
          ) : (
            <>
              <button
                onClick={() => {
                  closeMenu();
                  onRestore(menuClient);
                }}
                className="w-full text-left px-3 py-2 text-emerald-600 hover:bg-emerald-50"
              >
                Restore
              </button>

              {/* 🚨 DANGER ZONE */}
              <button
                onClick={() => {
                  closeMenu();
                  onDelete(menuClient); // ONLY trigger modal
                }}
                className="w-full text-left px-3 py-2 text-red-700 hover:bg-red-100"
              >
                Delete permanently
              </button>
            </>
          )}
        </DropdownMenu>
      )}
    </div>
  );
}
